import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { Tooltip, Fab } from '@mui/material';
import { ParentSize } from '@visx/responsive';
import DonutIcon from '@mui/icons-material/DonutLarge';
import ListIcon from '@mui/icons-material/FormatListBulletedRounded';
import GraphsLegend from './GraphsLegend';
import DonutChart from './DonutChart';
import { useAtomValue } from 'jotai';
import { themeAtom } from '../../Atoms';

/**Sums provided array of objects properties **/
const propertySum = (sourceArray, propertyName) =>
  sourceArray?.reduce((acc, curr) => acc + curr[propertyName], 0);
/****/

const CallStatsDonutChart = function CallStatsDonutChart({
  stats = {},
  tabValue = '',
}) {
  const intl = useIntl();
  const theme = useAtomValue(themeAtom);
  const [showLegend, setShowLegend] = useState(false);

  const toggleChartView = () => {
    setShowLegend(!showLegend);
  };

  return (
    <>
      {showLegend ? (
        <GraphsLegend
          legendData={stats?.legend?.data}
          legendColor={stats?.legend?.colors?.map((x) => x[theme])}
        />
      ) : (
        <ParentSize
          style={{
            flexGrow: 1,
          }}
        >
          {({ width, height }) => (
            //parent component passes his css properties to DonutChart
            <DonutChart
              themeMode={theme}
              width={width || 400}
              height={height || 400}
              dataToShow={stats?.donut}
              total={propertySum(stats?.donut, 'value')}
              text={
                stats?.text ??
                (tabValue && (intl.messages[tabValue] || tabValue))
              }
            />
          )}
        </ParentSize>
      )}
      <Tooltip
        title={showLegend ? intl.messages.SHOW_CHART : intl.messages.SHOW_LIST}
        placement="top"
      >
        <Fab
          id="change-view-fab"
          sx={{ position: 'absolute', bottom: 30, right: 30 }}
          color="primary"
          size="small"
          aria-label="change data display"
          onClick={toggleChartView}
        >
          {showLegend ? <DonutIcon /> : <ListIcon />}
        </Fab>
      </Tooltip>
    </>
  );
};

export default CallStatsDonutChart;
